<template>
  <button type="button" class="share__icon" v-tooltip="'Curtir'" @click="likeContent" aria-label="Curtir">
    <i v-if="liked" class="fas fa-thumbs-up"></i>
    <i v-else class="far fa-thumbs-up"></i>
  </button>
</template>

<script>
export default {
  props: {
    contentId: {
      type: String,
      default: null
    }
  },

  data: () => ({
    liked: false
  }),

  computed: {
    url() {
      const baseURI = '/api/v1/contents/:id/like'

      return baseURI.replace(':id', this.contentId)
    }
  },

  methods: {
    likeContent() {
      if (this.liked) return

      this.axios.put(this.url).then(() => {
        this.liked = true
      }).catch(() => {
        this.liked = false
      })
    }
  }
}
</script>
